module.exports = __webpack_public_path__ + "img/Zopilote Machine.d83f30ca.jpg";